<mat-form-field class="search-input-container flex-half">
  <mat-label>Find</mat-label>
  <input
    type="text"
    matInput
    [ngModel]="searchText"
    (ngModelChange)="onSearchTextChange($event)"
    name="search-input"
    autocomplete="off"
    />
    <mat-icon matSuffix class="list-search-icon">search</mat-icon>
  </mat-form-field>

  <mat-checkbox
    class="flex-half select-all-checkbox"
    [checked]="allPrivilegesChecked()"
    (change)="selectAllPrivileges($event)"
    color="primary"
    [disabled]="form.disabled"
    >Select All</mat-checkbox
    >

    <div [formGroup]="form">
      <div class="grid-header-border">
        <div class="grid-header">
          <div></div>
          <div>Add</div>
          <div>View</div>
          <div>Edit</div>
          <div>Delete</div>
          <div>Enabled</div>
        </div>
      </div>

      @for (
        categoryFilter of [
        administrativeFilter,
        callHistoryFilter,
        entitiesFilter,
        extensionsFilter,
        reportsFilter,
        setupFilter,
        systemFilter
        ]
        ; track
        categoryFilter) {
        @if (filterPrivileges(getPrivilegesByCategory(categoryFilter.categoryId)).length > 0) {
          <lcs-expansion-panel
            [expanded]="true"
            [togglePosition]="'before'"
            >
            <lcs-expansion-panel-header [togglePosition]="'before'">
              <div class="category-header">
                <div class="category-header-text">{{ getCategoryName(categoryFilter.categoryId) }}</div>
                @for (permission of ['isAdd', 'isView', 'isEdit', 'isDelete', 'isEnabled']; track permission) {
                  <div class="grid-checkbox-container">
                    @if (hasPermissionInCategory(categoryFilter.categoryId, permission)) {
                      <mat-checkbox
                        (change)="selectAllPrivilegesInCategory(categoryFilter.categoryId, permission, $event)"
                        [checked]="allPrivilegesInCategoryChecked(categoryFilter.categoryId, permission)"
                        color="primary"
                        [disabled]="form.disabled"
                      ></mat-checkbox>
                    }
                  </div>
                }
              </div>
            </lcs-expansion-panel-header>
            <lcs-expansion-panel-body>
              <div class="lcs-expansion-panel-body-container">
                @for (
                  privilege of filterPrivileges(getPrivilegesByCategory(categoryFilter.categoryId)); track
                  privilege; let i = $index) {
                  <div
                    class="grid-row"
                    [formGroupName]="privilege.privilegeId"
                    >
                    <div class="privilege-name-container">{{ privilege.displayName | addSpaces }}</div>
                    <div class="grid-checkbox-container"
                      >@if (privilege.isAdd) {
                      <mat-checkbox
                        formControlName="isAdd"
                        [ngClass]="{
                           'disabled-checkbox': privilegesGrantedByRole[privilege.privilegeId + '.' + 'isAdd']
                        }"
                        color="primary"
                        ></mat-checkbox
                        >
                    }</div>
                    <div class="grid-checkbox-container"
                      >@if (privilege.isView) {
                      <mat-checkbox
                        formControlName="isView"
                        [ngClass]="{
                           'disabled-checkbox': privilegesGrantedByRole[privilege.privilegeId + '.' + 'isView']
                        }"
                        color="primary"
                        ></mat-checkbox
                        >
                      }</div>
                      <div class="grid-checkbox-container"
                        >@if (privilege.isEdit) {
                        <mat-checkbox
                          formControlName="isEdit"
                        [ngClass]="{
                           'disabled-checkbox': privilegesGrantedByRole[privilege.privilegeId + '.' + 'isEdit']
                        }"
                          color="primary"
                          ></mat-checkbox
                          >
                        }</div>
                        <div class="grid-checkbox-container"
                          >@if (privilege.isDelete) {
                          <mat-checkbox
                            formControlName="isDelete"
                        [ngClass]="{
                           'disabled-checkbox': privilegesGrantedByRole[privilege.privilegeId + '.' + 'isDelete']
                        }"
                            color="primary"
                            ></mat-checkbox
                            >
                          }</div>
                          <div class="grid-checkbox-container"
                            >@if (privilege.isEnabled) {
                            <mat-checkbox
                              formControlName="isEnabled"
                        [ngClass]="{
                           'disabled-checkbox': privilegesGrantedByRole[privilege.privilegeId + '.' + 'isEnabled']
                        }"
                              color="primary"
                              ></mat-checkbox
                              >
                            }</div>
                          </div>
                        }
                      </div>
                    </lcs-expansion-panel-body>
                  </lcs-expansion-panel>
                }
              }
            </div>
